function handleBadgeDisplay() {
  const promoText = document.getElementById('badge-text-container');
  const mobilePromoText = document.getElementById('badge-text-container-m');
  if (!promoText && !mobilePromoText) return;

  const allApplicablePromos = promoText
    ? promoText.querySelectorAll('.fs-custom-single-promo')
    : [];
  const allApplicableMobilePromos = mobilePromoText
    ? mobilePromoText.querySelectorAll('.fs-custom-single-promo')
    : [];

  if (!allApplicablePromos.length && !allApplicableMobilePromos.length) {
    return;
  }

  const getCurrentUTCTime = () => {
    const now = new Date();
    return now.toISOString();
  };

  const getStartTime = (startTime) => {
    if (!startTime) return null;

    const start = new Date(startTime);
    if (isNaN(start.getTime())) return null;

    return start.toISOString();
  };

  const getEndTime = (endTime) => {
    if (!endTime) return null;

    const end = new Date(endTime);
    if (isNaN(end.getTime())) return null;

    return end.toISOString();
  };

  const isPromoActive = (start, end, persist) => {
    if (persist == 'true') {
      return true;
    }
    const currentTime = getCurrentUTCTime();
    const startTime = getStartTime(start);
    const endTime = getEndTime(end);

    if (!startTime || !endTime) {
      return false;
    }

    return currentTime >= startTime && currentTime <= endTime;
  };

  const isPromoVisible = (promoEl) => {
    const currPromoStart = promoEl.getAttribute('data-start-time');
    const currPromoEnd = promoEl.getAttribute('data-end-time');
    const currPromoPersist = promoEl.getAttribute('data-promo-continue');
    const currPromoInAppOnly = promoEl.getAttribute('data-app-only');
    const currPromoNotInApp = promoEl.getAttribute('data-not-in-app');
    const currPromoUtmParams = promoEl.getAttribute('data-utm-params');

    const urlParams = new URLSearchParams(window.location.search);
    const isInApp = (urlParams.get('app') || '').trim().toLowerCase().startsWith('kinn');

    if (isInApp && currPromoNotInApp === 'true') return false;
    if (!isInApp && currPromoInAppOnly === 'true') return false;

    if (currPromoUtmParams) {
      const utmArr = currPromoUtmParams.split(',');
      let hasMatchingUtm = false;

      for (let utmCombo of utmArr) {
        const utmPairs = utmCombo.split('&');
        const allPairsMatch = utmPairs.every((pair) => {
          const [key, value] = pair.trim().split('=');
          return urlParams.get(key) === value;
        });

        if (allPairsMatch) {
          hasMatchingUtm = true;
          break;
        }
      }

      if (!hasMatchingUtm) return false;
    }

    return isPromoActive(currPromoStart, currPromoEnd, currPromoPersist);
  };

  const isDesktop = window.innerWidth > 768;
  const promosToCheck = isDesktop ? allApplicablePromos : allApplicableMobilePromos;
  const fallbackPromos = isDesktop ? allApplicableMobilePromos : allApplicablePromos;
  const candidates = promosToCheck.length ? promosToCheck : fallbackPromos;

  for (let i = 0; i < candidates.length; i++) {
    if (isPromoVisible(candidates[i])) {
      candidates[i].style.display = 'block';
      break;
    }
  }
}

if (document.readyState !== 'loading') {
  handleBadgeDisplay();
} else {
  document.addEventListener('DOMContentLoaded', () => {
    handleBadgeDisplay();
  });
}
